import api from './api';
// 通过httpFactory 返回的请求方式将变为 this.[api名称](参数的形式)
// other 提供全局处理调整请求参数的方法
function httpFactory(mc, other) {
  function findDuplicates(arr) {
    let duplicates = [];
    for (let i = 0; i < arr.length - 1; i++) {
      for (let j = i + 1; j < arr.length; j++) {
        if (arr[i] === arr[j] && !duplicates.includes(arr[i])) {
          duplicates.push(arr[i]);
        }
      }
    }
    return duplicates;
  }
  const duplicateNums = findDuplicates(Object.values(api));
  // 默认不报错提醒
  if (duplicateNums.length) {
    console.error('重复API--------------------------', duplicateNums);
  }
  let tmp = {};
  Object.keys(api).forEach((key) => {
    tmp[key] = function (params, config, mcType, flag) {
      let newParams = params;
      let newConfig = config;
      let newMcType = mcType;
      let newFlag = flag;
      if (other && typeof other[key] === 'object') {
        let obj = other[key];
        newParams = { ...(obj.params || {}), ...params };
        newConfig = { ...(obj.config || {}), ...config };
        newMcType = mcType || obj.mcType;
        newFlag = flag || obj.flag;
      }
      return mc.postForm(api[key], newParams, newConfig, newMcType, newFlag);
    };
  });
  return tmp;
}

export default {
  install(Vue, mc, other) {
    Vue.$http = Vue.prototype.$http = httpFactory(mc, other);
  }
};



// WEBPACK FOOTER //
// ./src/api/index.js